import React from 'react';
import { Tooltip } from 'antd';
import { useStateContext } from '@/context/StateContext';
import Image from 'next/image';

const DMARCTable = ({ products, selectedOption, getSelectedProductOption }) => {
  const { onAddDmarc, setShowCart } = useStateContext();

  const handleBuyNow = (product) => {
    const selectedProductOption = getSelectedProductOption(product.id);
    const formattedProduct = {
      ...product,
      name: `DMARC ${product.name}`,
      type: 'dmarc',
      features: [
        {
          name: 'Emails',
          type: 'select',
          options: product.options.map((opt) => ({
            value: opt.emails,
            price: opt.price,
            msrp: opt.msrp,
            annualPrice: opt.annualPrice,
          })),
        },
        {
          name: 'Domains',
          value: product.id === 'dmarc-plus' ? '2' : '4',
          type: 'static',
        },
      ],
      price: selectedProductOption.price,
      selectedOption: selectedOption[product.id],
    };

    onAddDmarc(formattedProduct, 1, selectedOption[product.id]);
    setShowCart(true);
  };

  const renderPlusColumn = () => {
    const plusProduct = products.find((p) => p.id === 'dmarc-plus');
    const selectedProductOption = getSelectedProductOption(plusProduct.id);

    return (
      <div className="pricing-column">
        <div className="pricing-table-top">
          <div className="mg-bottom-8px">
            <div
              className="text-300 color-neutral-600"
              style={{ textDecoration: 'line-through', marginBottom: '8px', textAlign: 'center' }}
            >
              MSRP ${selectedProductOption.msrp.toFixed(2)}
            </div>
            <div className="text-400 bold color-neutral-800">
              ${selectedProductOption.price.toFixed(2)}/month
            </div>
          </div>
          <h2 className="text-500 bold color-accent-1 mg-bottom-0 product-heading">Plus</h2>
          <div className="width-100 mg-top-24px">
            <a
              href="#"
              className="btn-primary small pricing-table-btn w-button"
              onClick={() => handleBuyNow(plusProduct)}
            >
              Buy Now
            </a>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">Up to {selectedProductOption.emails}</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">2</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">3 Months</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">1</div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderPremiumColumn = () => {
    const premiumProduct = products.find((p) => p.id === 'dmarc-premium');
    const selectedProductOption = getSelectedProductOption(premiumProduct.id);

    return (
      <div
        className="pricing-column featured"
        style={{ position: 'relative', overflow: 'visible' }}
      >
        <div
          style={{
            height: '37px',
            left: '50%',
            position: 'absolute',
            top: '-12px',
            transform: 'translateX(-50%)',
            width: '192px',
            zIndex: 2,
          }}
        >
          <Image
            src="/images/ribbon-most-popular.svg"
            alt="Most Popular"
            fill
            style={{ objectFit: 'contain' }}
          />
        </div>

        <div className="pricing-table-top featured">
          <div className="mg-bottom-8px">
            <div
              className="text-300 color-neutral-600"
              style={{ textDecoration: 'line-through', marginBottom: '8px', textAlign: 'center' }}
            >
              MSRP ${selectedProductOption.msrp.toFixed(2)}
            </div>
            <div className="text-400 bold color-neutral-800">
              ${selectedProductOption.price.toFixed(2)}/month
            </div>
          </div>
          <h2 className="text-500 bold color-accent-1 mg-bottom-0 product-heading">Premium</h2>
          <div className="width-100 mg-top-24px">
            <a
              href="#"
              className="btn-primary small pricing-table-btn w-button"
              onClick={() => handleBuyNow(premiumProduct)}
            >
              Buy Now
            </a>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">Up to {selectedProductOption.emails}</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">4</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">1 Year</div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="text-300 medium">Unlimited</div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img
                src="/images/icon-check-green-bg.svg"
                loading="eager"
                alt=""
                className="image cover"
              />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper empty"></div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
        <div className="pricing-content-wrapper">
          <div className="inner-container _28px">
            <div className="image-wrapper circle-image">
              <img src="/images/icon-x.svg" loading="eager" alt="" className="image cover" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderEnterpriseColumn = () => (
    <div className="pricing-column">
      <div className="pricing-table-top">
        <div className="mg-bottom-8px center">
          <div className="text-200 medium color-neutral-600">Contact Us</div>
        </div>
        <h2 className="text-400 bold color-neutral-800 product-heading enterprise">Enterprise</h2>
        <div className="width-100 mg-top-24px">
          <a
            href="/contact"
            className="btn-primary small pricing-table-btn w-button btn-charcoal-light"
          >
            Contact Us
          </a>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="text-300 medium">Up to Unlimited</div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="text-300 medium">Up to Unlimited</div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="text-300 medium">Unlimited</div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="text-300 medium">Unlimited</div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper empty"></div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
      <div className="pricing-content-wrapper">
        <div className="inner-container _28px">
          <div className="image-wrapper circle-image">
            <img
              src="/images/icon-check-green-bg.svg"
              loading="eager"
              alt=""
              className="image cover"
            />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="overflow-hidden border-radius-40px---bottom">
      <section className="section pd-top-0px bg-neutral-100">
        <div className="container-default w-container">
          <div className="inner-container _600px---mbl center">
            <div className="mg-bottom-80px">
              <div className="inner-container _604px center">
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    paddingTop: '48px',
                    paddingBottom: '48px',
                  }}
                >
                  <Image src="/images/logo-easydmarc.svg" alt="Check" width={163} height={34} />
                </div>

                <div className="text-center mg-bottom-40px">
                  <h2 className="display-2">Features & Benefits</h2>
                  <p>
                    Explore the key advantages and capabilities designed to enhance your email
                    security, streamline domain management, and boost brand trust with seamless
                    integration and comprehensive support.
                  </p>
                </div>
              </div>
            </div>

            <div className="w-layout-grid pricing-tablet">
              <div className="pricing-column first">
                <div className="pricing-table-top first">
                  <div className="text-400 bold color-neutral-800">Core</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">Monthly Emails</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">Domains</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">Data History</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">User</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Reports</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Visualize your Aggregate XML file and take steps toward achieving full DMARC compliance."
                    >
                      Aggregate Reports (RUA){' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Monitor your sending source locations and categorize them for enhanced visibility."
                    >
                      Aggregate GeoMaps{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Review your DMARC progress weekly to maintain a comprehensive overview of your domain environment."
                    >
                      Weekly Email Reports{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Analyze DMARC failure reports to accelerate your DMARC deployment."
                    >
                      Failure Reports (RUF){' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Automatically track your sub-domains in Aggregate Reports to avoid manually adding."
                    >
                      Subdomain Detection{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Detect and identify your sending sources to enhance visibility."
                    >
                      Email Vendor Identification{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Visualize your TLS reports and take action to enforce your policy."
                    >
                      TLS Reports{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Access</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Manage user access and review admin roles for domains, reporting, and other features."
                    >
                      Permission Management{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Easily manage your users and customize their permissions by groups, simplifying your administrative tasks."
                    >
                      Group Management{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Security</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Additional layer of protection to strengthen your security."
                    >
                      Two-Factor Authentication (2FA){' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Use a single set of login credentials to access multiple DMARC applications or systems."
                    >
                      Single Sign-On (SSO){' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Managed Solutions</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Configure, implement, and manage DMARC without leaving our environment."
                    >
                      Managed DMARC{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Configure, implement, and manage BIMI centrally from one location."
                    >
                      Managed BIMI{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Enhance your SPF record to overcome the “Too many DNS lookups” issue."
                    >
                      Easy SPF{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Configure, implement, and manage MTA-STS effortlessly inside our environment."
                    >
                      Managed MTA-STS{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Miscellaneous</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Email security protocol checkers and generators."
                    >
                      SPF, DKIM, BIMI Tools{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Instantly troubleshoot a specific email source without waiting for Aggregate Reports."
                    >
                      Email Investigation{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Extract URLs from a text and check their trustworthiness."
                    >
                      Phishing URL Check{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Monitor your IP sources in Aggregate Reports. Click to review each IP and its standing."
                    >
                      IP Source Monitoring{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Receive insights and news, get acquainted with email experts, and leverage networking opportunities."
                    >
                      Access To Private Community{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Take control of your alerts by creating, customizing, and managing them, ensuring you stay informed and proactive."
                    >
                      Alert Management{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Avoid deliverability issues and get notified in case your domain ends up in a blacklist."
                    >
                      Reputation Monitoring{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-400 bold color-neutral-800">Support</div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Access a comprehensive resource hub with indepth information and support to maximize your understanding of our services."
                    >
                      Knowledge Base{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Open your email security roadblocks with the help of our DMARC experts."
                    >
                      Email Support{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Our Enterprise Managed Services along with fixed video calls, onboarding and preparation with clear actions points and Engineer guidance with take you through the DMARC journey      ."
                    >
                      Managed Services{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Receive guidance from a dedicated DMARC Engineer who will assist you throughout the implementation process."
                    >
                      Dedicated Engineer{' '}
                    </Tooltip>
                  </div>
                </div>
                <div className="pricing-content-wrapper left">
                  <div className="text-300 color-neutral-800">
                    <Tooltip
                      className="tooltip"
                      title="Let DMARC specialists analyze your reports and give you a full review of your outgoing email ecosystem in terms of authentication scopes (DKIM, SPF, DMARC)."
                    >
                      Audit Reports{' '}
                    </Tooltip>
                  </div>
                </div>
              </div>

              {renderPlusColumn()}
              {renderPremiumColumn()}
              {renderEnterpriseColumn()}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default DMARCTable;
